import { graphql } from "../gql";

export const getAskAutodorQueueNamesQueryDoc = graphql(`
  query getAskAutodorQueueNames {
    askAutodorQueueNames {
      ...AskAutodorQueueNameFragment
    }
  }
`);
